// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"20104a39","359":"9e4f7992","419":"99a50e22","593":"83770580","787":"2aa63715","942":"be690847"}[chunkId] + ".chunk.js";
};